import $ from "jquery";
import {Modal} from "bootstrap";

export const init = () => {
  let attempts = 0;

  if ($('.link.link--modal').length > 0 && $('#link-modal').length == 0) {
    $('main').append('<div id="link-modal" class="modal fade" tabindex="-1" role="dialog">\n' +
      '    <div class="modal-dialog modal-xl" role="document">\n' +
      '        <div class="modal-content">\n' +
      '            <div class="modal-header">\n' +
      '                <div></div>\n' +
      '                <button class="btn btn--close" type="button" data-bs-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>\n' +
      '            </div>\n' +
      '            <div id="link-modal-content" class="modal-body standard-modal"></div>\n' +
      '        </div>\n' +
      '    </div>\n' +
      '</div>');
  }
  $('.link.link--modal').each(function () {
    $(this).attr('data-bs-toggle', 'modal');
    $(this).attr('data-bs-target', '#link-modal');
    let href = $(this).attr('href');
    if (href.endsWith('/')) {
      href = href.slice(0, -1);
    }
    $(this).attr('data-url', `${window.location.origin}${href}?type=1332`);
    $(this).attr('href', 'javascript:void(0);');
  });

  let modalElementList = document.querySelectorAll(".modal");
  [...modalElementList].map((modal) => new Modal(modal));

  // if document.ready needed
  const whenComplete = () => {
    if (attempts > 30) return;
    attempts += 1;
    if (document.readyState === "complete") {

      let linkModal = document.getElementById("link-modal");
      linkModal.addEventListener("show.bs.modal", (event) => {
        // Button that triggered the modal
        let link = $(event.relatedTarget);

        // Extract info from data-* attributes
        let ajaxUrl = link.data("url");
        $.ajax({
          url: ajaxUrl,
          context: document.body,
        })
          .done(function (data) {
            $("#link-modal-content").html(data);

            $("#link-modal-content").find(".collapse").each(function () {
              let $this = $(this);
              if (!$this.hasClass("show")) {
                $this.parent().find(".panel-info__btn > [data-bs-toggle]").addClass("collapsed");
              }
          })
        })
          .fail(function () {
            console.warn("Error. Couldn't get data from server.");
          });
      });
    } else {
      setTimeout(function () {
        whenComplete();
      }, 400);
    }
  };
  whenComplete();
};
